import React from 'react';

const Orders = () => {
    return (
        <div>
            <h1>Order list on progress...</h1>
        </div>
    );
};

export default Orders;